import * as Yup from 'yup'

import { INTEGRATIONS_FORM_FIELD } from '../RentalPortalIntegrations.constants'

export function getIntegrationsConnectFormSchema() {
  return Yup.object().shape({
    [INTEGRATIONS_FORM_FIELD.host]: Yup.string().ensure().required(true),
    [INTEGRATIONS_FORM_FIELD.secret]: Yup.string().ensure().required(true),
    [INTEGRATIONS_FORM_FIELD.username]: Yup.string().ensure().required(true),
  })
}
